import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InOutWarehousingService {

  constructor(
    private http: HttpClient
  ) { }


  searchInOutWarehousing(inOutWarehousingForm: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/inOutWarehousing/search/inOutWarehousing`;
    return this.http.post(url, inOutWarehousingForm);
  }


  searchInOutWarehousingDetail(inOutNo: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/inOutWarehousing/search/inOutWarehousingDetail/${inOutNo}`;
    return this.http.get(url);
  }

  searchInOutReport(req: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/inOutWarehousing/searchInOutReport`;
    return this.http.post(url, req);
  }

  exportInOutReport(params: any,language: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/inOutWarehousing/exportInOutReport/${language}`;
    return this.http.post(url, params, { responseType: 'blob' });
  }
}
